import { combineReducers }    from 'redux-immutable';
import buildErrorsReducer     from './buildErrorsReducer';
import buildInProgressReducer from './buildInProgressReducer';
import buildAllItemsReducers  from './items/buildAllItemsReducers';
import buildAllListReducers   from './list/buildAllListReducers';


const buildAllResourceReducers = (resource) => combineReducers({
  items:      buildAllItemsReducers(resource),
  list:       buildAllListReducers(resource),
  inProgress: buildInProgressReducer(resource),
  errors:     buildErrorsReducer(resource),
});


export default buildAllResourceReducers;


// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/buildAllResourceReducers.js